import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class CustomerReportingService {

  constructor(private apiService: ApiService) {}

  /**
   * Get change offers eligible list
   */
  getReporting(period: number): Observable<any> {
    return this.apiService.get('reporting/customer/' + period);
  }
}
